/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { addSpanToAll } from '@atlaskit/react-ufo/interaction-metrics';

export const wrapPromiseWithFetchInteraction = <R,>(
	promise: Promise<R>,
	name: string,
	type: 'fetch' | 'graphql' = 'fetch',
): Promise<R> => {
	const fetchStartTime = performance.now();
	return promise.then((response) => {
		addSpanToAll(
			type,
			name,
			[{ name: 'network' }, { name: 'jpdApp' }],
			fetchStartTime,
			performance.now(),
		);
		return response;
	});
};
